export default "__VITE_ASSET__BxaGYJHb__"